import { FormHelperText as RawHelperText } from "@material-ui/core";
import Theme from "../../Theme";
import styled from "styled-components";

export default styled(RawHelperText)`
  font-size: 14px;
  color: ${Theme.colors.blackText};
`;
